import { useNavigate } from "react-router-dom";
import {
  IWhitespaceMenuItem,
  WhitespaceMenu,
  Error
} from "@whitespace/whitespace-ui";
import { useStateMachine } from "little-state-machine";
import { useEffect } from "react";
import { useAmplifyREST } from "hooks/useAmplifyREST";
import { updateMenuItems } from "actions/updateMenuItems";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import { updateIsMenuOpen } from "actions/updateIsMenuOpen";

export const HwrcMenuWrapper = () => {
  const { state } = useStateMachine();
  const { actions } = useStateMachine({
    updateMenuItems,
    updateIsMenuOpen
  });

  const navigate = useNavigate();

  const {
    isSending,
    errors,
    data,
    statusCode,
    sendRequest
  } = useAmplifyREST();

  useEffect(() => {
    if (!state.menuItems || !state.menuItems.length) sendRequest("menu", "GET");
  }, [sendRequest]);

  useEffect(() => {
    if (statusCode === 401) navigate(RoutePathsEnum.Unauthorised);
  }, [statusCode]);

  useEffect(() => {
    if (data) {
      actions.updateMenuItems(data as IWhitespaceMenuItem[]);
    }
  }, [data, actions]);

  const logout = () => {
    navigate(RoutePathsEnum.Logout);
  };

  const items: IWhitespaceMenuItem[] = state.menuItems
    ? state.menuItems
    : [];

  return (
    <>
      {errors && <Error />}
      <WhitespaceMenu
        items={items}
        showLogout
        logoutHandler={logout}
        menuOpenHandler={actions.updateIsMenuOpen}
        isMenuOpen={state.isMenuOpen!}
        displayUsername={state.username!}
        rootReturnUrl="/"
      />
      {isSending && <span data-testid="isSending" />}
    </>
  );
};
